import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi, type TransferRequestResponse, type TransferRequestUpdateRequest } from '@shared/api';

const updateTransferEffect = createEffect((request: TransferRequestUpdateRequest) => TransferRequestsApi.update(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestResponse | null>(null)
  .on(updateTransferEffect.done, (_, data) => data.result.data! || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateTransferEffect.pending, (_, data) => data)
  .on(updateTransferEffect.fail, () => false)
  .on(updateTransferEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateTransferEffect, () => null)
  .on(
    updateTransferEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Transfer. Please try again.').message,
  )
  .on(updateTransferEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferRequestsUpdateStore = {
  events: {
    updateTransfer: updateTransferEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
